<template>
  <div id="cardDesti">
      <slither-slider :options="{numberOfSlides: 8,
                                  dots: false,
                                  controls: true}">
      <div v-for="(region, index) in regions.filter(x => x.photo && x.get_lodgings && x.get_lodgings.length > 0)" :key='index'>
        <div class="col-grid-desti" v-if="region.photo">
          <div class="col-grid-desti-card" :class="index % 2 === 0 ? '' : 'transform-card'" @click="goToGroup('/destination/'+ region.slug)">
            <div class="zoom-img-container">
              <img :src="region.photo" :alt="region.name" class="zoom-img">
            </div>
            <a class="raleway-bold-p16">
              <p class="region-name text-center no-translate">{{ region.name }}</p>
            </a>
          </div>
        </div>
      </div>
      <template slot="previous">
        <div class="circle-icon previous-slide-button">
          <img src="../../images/arrow-left.svg" alt="Previous" />
        </div>
      </template>
      <template slot="next">
        <div class="circle-icon next-slide-button">
          <img src="../../images/arrow-right.svg" alt="Next" />
        </div>
      </template>
    </slither-slider>
  </div>
</template>

<script>
  export default {
    name: 'CardDesti',
    props: ['regions'],
    methods: {
      goToGroup(url) {
        window.open(url, '_blank');
      }
    },
  }
</script>

<style lang="scss" scope='app/assets/stylesheets/components/destination'>
</style>

<style scoped>
.zoom-img-container {
  border-radius: 15px;

  img {
   border-radius: 15px; 
  }
}
</style>